<div class="header">
  <p class="header-title">audio mixer</p>
</div>

<!-- Indicators / dB Scale -->
<div class="indicators">
  <div class="headphones-placeholder"></div>
  <div class="db-scale">
    <p *ngFor="let db of dbScale" class="db-value">{{ db }}</p>
  </div>
  <div class="headphones-placeholder"></div>
</div>

<!-- Channels Container -->
<div class="channels-container">
  <div
    class="channel"
    *ngFor="let channel of activeAudioChannels; let i = index"
  >
    <div class="channel-icon-container">
      <evrideo-headphones-icon
        class="cursor-pointer"
        [hidden]="!channel.isLiveFeed"
        [muted]="channel.previewListenMuted"
        (mutedChange)="onHeadphonesMutedChange($event, channel)"
        (click)="$event.stopPropagation()"
      ></evrideo-headphones-icon>
    </div>
    <div class="channel-controls">
      <div class="channel-name">
        <p
          [contentEditable]="channel.isLiveFeed"
          [attr.contenteditable]="channel.isLiveFeed"
          (focus)="channel.isLiveFeed && onChannelNameFocus(i, $event)"
          (blur)="channel.isLiveFeed && onChannelNameBlur($event, channel, i)"
          (keydown.enter)="$event.preventDefault(); $any($event.target).blur()"
          (paste)="channel.isLiveFeed && onChannelNamePaste($event)"
        >
          {{ channel.name }}
        </p>
      </div>
      <div class="volume-controls">
        <div class="volume-bars">
          <!-- <div
            *ngFor="let i of volumeBars"
            class="volume-bar"
            [style.background-color]="getVolumeBarColor(i)"
          ></div> -->
        </div>
        <div
          class="slider-container"
          (mousemove)="onSliderMouseMove($event, channel)"
          (mouseleave)="onSliderMouseLeave(channel)"
        >
          <div class="slider-track"></div>
          <input
            type="range"
            #sliderInput
            class="slider-input"
            min="0"
            max="5"
            step="1"
            [value]="volumeToSliderPosition(channel.volumeLevel)"
            [title]="getTooltipForChannel(channel, toNumber(sliderInput.value))"
            (input)="onVolumeChange(channel, $any($event.target).value)"
            (click)="onVolumeChange(channel, $any($event.target).value)"
          />
          <div
            class="slider-handle"
            [style.left.%]="PositionToPercentage(toNumber(sliderInput.value))"
            [title]="getTooltipForChannel(channel, toNumber(sliderInput.value))"
          ></div>
        </div>
      </div>
    </div>
    <div class="channel-icon-container">
      <evrideo-not-allowed-icon
        class="cursor-not-allowed"
        *ngIf="channel.isLiveFeed && channel.isClearedForAir == false"
        [title]="'not cleared for air'"
      ></evrideo-not-allowed-icon>
      <evrideo-sound-icon
        [ngClass]="{ 'cursor-pointer': channel.isLiveFeed }"
        (click)="onSoundClick($event, channel)"
        [muted]="channel.isMuted"
        [title]="channel.isMuted ? 'Unmute' : 'Mute'"
        *ngIf="channel.isLiveFeed && channel.isClearedForAir"
      ></evrideo-sound-icon>
      <div
        [ngClass]="{ 'three-dots-icon': true, disabled: !channel.isLiveFeed }"
        [hidden]="!channel.isLiveFeed"
        (click)="onThreeDotsClick(i, $event, channel)"
      >
        <svg
          width="5"
          height="15"
          viewBox="0 0 5 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5 10.75C3.125 10.75 3.6875 11.0938 4 11.625C4.3125 12.1875 4.3125 12.8438 4 13.375C3.6875 13.9375 3.125 14.25 2.5 14.25C1.84375 14.25 1.28125 13.9375 0.96875 13.375C0.65625 12.8438 0.65625 12.1875 0.96875 11.625C1.28125 11.0938 1.84375 10.75 2.5 10.75ZM2.5 5.75C3.125 5.75 3.6875 6.09375 4 6.625C4.3125 7.1875 4.3125 7.84375 4 8.375C3.6875 8.9375 3.125 9.25 2.5 9.25C1.84375 9.25 1.28125 8.9375 0.96875 8.375C0.65625 7.84375 0.65625 7.1875 0.96875 6.625C1.28125 6.09375 1.84375 5.75 2.5 5.75ZM4.25 2.5C4.25 3.15625 3.90625 3.71875 3.375 4.03125C2.8125 4.34375 2.15625 4.34375 1.625 4.03125C1.0625 3.71875 0.75 3.15625 0.75 2.5C0.75 1.875 1.0625 1.3125 1.625 1C2.15625 0.6875 2.8125 0.6875 3.375 1C3.90625 1.3125 4.25 1.875 4.25 2.5Z"
          />
        </svg>
      </div>
    </div>
  </div>
</div>

<!-- Context Menu -->
<div
  class="context-menu"
  *ngIf="showContextMenu"
  [style.left.px]="contextMenuPosition.x"
  [style.top.px]="contextMenuPosition.y"
>
  <div class="context-menu__item" (click)="toggleClearedForAir()">
    {{
      getSelectedChannel()?.isClearedForAir
        ? "Unclear for air"
        : "Clear for air"
    }}
  </div>
</div>
